import { Fragment, useEffect, useState } from 'react';
import { useCookieConsent } from '../CookieConsentProvider';
import { fullstory } from '../../config';

export const FullstoryTracking = ({ component, location, consentFn }) => {
  const consent = useCookieConsent();

  const [initialized, setInitalized] = useState(false);

  useEffect(() => {
    const setInit = () => setInitalized(true);
    if (!initialized) {
      if (consent.status === 'accepted') {
        consentFn(true);
        setInit();
      } else if (consent.status === 'declined') {
        consentFn(false);
        setInit();
      }
    }
  }, [
    consent,
    location.pathname,
    location.search,
    initialized,
    consentFn
  ]);

  const Fullstory = component;

  return (
    <Fragment>
      {(component && initialized) && (
        <Fullstory {...fullstory} />
      )}
    </Fragment>
  );

}
